
<div class="text-center">
	<ul class="lu-pagination list-unstyled">
		<li class="active-page o-flex o-flex--vcenter o-flex--center pr-12 mr-12" [attr.aria-label]="('lup.a11y.pagination_current_page' | translate) + ' ' + page">
			<span>{{ ('lup.a11y.pagination_page' | translate) + ' ' + page }}</span>
		</li>
		<li class="lu-pagination__pre" [ngClass]="{'disabled': !hasPrevious }">
			<button class="btn btn--ico" (click)="previousPage()" [title]="'lup.a11y.pagination_previous_page' | translate" [disabled]="!hasPrevious">
				<lu-icon class="lui" icon="long-arrow-left"></lu-icon>
			</button>
		</li>
		<li class="lu-pagination__nxt" [ngClass]="{'disabled': !hasNext }">
			<button class="btn btn--ico" (click)="nextPage()" [title]="'lup.a11y.pagination_next_page' | translate" [disabled]="!hasNext">
				<lu-icon class="lui" icon="long-arrow-right"></lu-icon>
			</button>
		</li>
	</ul>
</div>
